export class ErrorDialog {
    dialogHeader: string;
    dialogBody: string;
}
